<template>
  <div class="flex flex-col gap-4 text-left" data-testid="upload-modal-new-sheet-step">
    <p class="text-sm text-neutral50" data-testid="upload-modal-new-sheet-text">
      A folha de <b>{{ formattedDate }}</b> {{ targetsLabel }} foi reprovada. Envie a folha
      selecionada como <b>nova folha</b>: a folha recusada continua disponível em “Folhas
      anteriores” e {{ returnsLabel }} para <b>Aguardando Auditoria</b>.
      <template v-if="hasOtherSchedules">
        As demais escalas selecionadas recebem a mesma folha normalmente.
      </template>
    </p>
    <v-textarea
      :model-value="modelValue"
      label="Justificativa"
      placeholder="Ex.: folha corrigida após a reprovação"
      variant="outlined"
      density="compact"
      rows="3"
      counter="1000"
      maxlength="1000"
      :hint="hint"
      persistent-hint
      data-testid="upload-modal-new-sheet-justification"
      @update:model-value="emit('update:modelValue', $event ?? '')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { NEW_SHEET_MIN_JUSTIFICATION } from './rejected-sheet'

const props = withDefaults(
  defineProps<{
    modelValue: string
    formattedDate: string
    /** Escalas dos registros reprovados que recebem a nova folha (#3072). */
    targets?: string[]
    /** A folha também vai, pelo envio normal, para outras escalas da seleção. */
    hasOtherSchedules?: boolean
  }>(),
  { targets: () => [], hasOtherSchedules: false }
)

const targetsLabel = computed(() => {
  if (!props.targets.length) return 'deste registro'
  const quoted = props.targets.map((name) => `“${name}”`)
  return props.targets.length === 1
    ? `da escala ${quoted[0]}`
    : `das escalas ${quoted.slice(0, -1).join(', ')} e ${quoted[quoted.length - 1]}`
})
const returnsLabel = computed(() =>
  props.targets.length > 1 ? 'os registros voltam' : 'o registro volta'
)
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()

const hint = computed(() =>
  props.modelValue.trim().length < NEW_SHEET_MIN_JUSTIFICATION
    ? `Obrigatória — mínimo de ${NEW_SHEET_MIN_JUSTIFICATION} caracteres`
    : ''
)
</script>
